<mat-form-field class="form-control" style="width: 100%" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    placeholder="Sample"
    [placeholder]="label ? label : 'Sample'"
  />
  <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error>
</mat-form-field>
